<freud-divider></freud-divider>
<div
	*ngIf="!isLoading"
	class="zk-flex zk-flex-row zk-gap-2 zk-justify-end zk-p-4 zk-pr-8 zk-pt-1"
>
	<freud-button
		id="cancel-event-button"
		*ngIf="shouldShowCancelInviteButton()"
		(keyup)="$event.key === 'Enter' ? cancelInvite() : null"
		(click)="cancelInvite()"
		color="ghost"
		[label]="'APPOINTMENTS.DETAILS.FOOTER.CANCEL_INVITE' | translate"
	>
	</freud-button>

	<freud-button
		id="schedule-new-session-button"
		*ngIf="shouldShowScheduleNewSessionButton()"
		(keyup)="$event.key === 'Enter' ? scheduleNewSession() : null"
		(click)="scheduleNewSession()"
		color="ghost"
		[label]="'APPOINTMENTS.DETAILS.FOOTER.SCHEDULE_NEW_SESSION' | translate"
	>
	</freud-button>

	<freud-button
		id="reschedule-button"
		color="ghost"
		*ngIf="shouldShowRescheduleButton()"
		(keyup)="$event.key === 'Enter' ? emitRescheduleEvent() : null"
		(click)="emitRescheduleEvent()"
		[label]="'APPOINTMENTS.DETAILS.FOOTER.RESCHEDULE' | translate"
	>
	</freud-button>

	<freud-button
		id="show-chat-button"
		*ngIf="shouldShowChatButton()"
		(keyup)="$event.key === 'Enter' ? showChat() : null"
		(click)="showChat()"
		color="secondary"
		[label]="'APPOINTMENTS.DETAILS.FOOTER.CHAT' | translate"
	>
	</freud-button>

	<freud-button
		id="promptuary-button"
		*ngIf="shouldShowPromptuaryButton()"
		(keyup)="$event.key === 'Enter' ? goToPromptuary() : null"
		(click)="goToPromptuary()"
		[label]="getPromptuaryButtonLabel()"
	>
	</freud-button>

	<freud-button
		id="start-session-button"
		*ngIf="shouldShowStartSessionButton()"
		(keyup)="$event.key === 'Enter' ? startSession() : null"
		(click)="startSession()"
		[disabled]="shouldDisableStartSessionButton()"
		[label]="'APPOINTMENTS.DETAILS.FOOTER.START_SESSION' | translate"
	>
	</freud-button>
</div>
<freud-confirm-dialog></freud-confirm-dialog>
<appointment-delete-recurrency-modal
	[isOpen]="isCancelRecurrencyAppointmentModalOpen"
	[appointmentId]="event?.id"
	(onClose)="isCancelRecurrencyAppointmentModalOpen = false"
	(onCancel)="showEvents.emit(); refreshEvents.emit();"
></appointment-delete-recurrency-modal>
